import { createContext, Dispatch, SetStateAction } from "react";
import { UserCPanelModel } from "@jugl-web/rest-api";
import { Subject } from "rxjs";

type OpenedSideBar = {
  user?: UserCPanelModel;
  sideBar:
    | "loginActivity"
    | "documents"
    | "invite"
    | "userProfile"
    | "profileAttributes";
};
type OpenedAlert = {
  alert: "copyInvitation";
};

export interface CPanelPageContextValue {
  searchQuery: string;
  selectedUsers: UserCPanelModel[];
  setSearchQuery: Dispatch<SetStateAction<string>>;
  toggleUserSelectState: (selectedUser: UserCPanelModel) => void;
  clearSelectedUsers: () => void;

  openedSideBar: OpenedSideBar | null;
  openedAlert: OpenedAlert | null;
  setOpenedSideBar: (sideBar: OpenedSideBar | null) => void;
  setOpenedAlert: (alert: OpenedAlert | null) => void;

  updateUserDocCountDelta: (userId: string, delta: number) => void;
  userIdToDocCountDelta: Record<string, number>;
  resetUserDocCountDelta: () => void;

  refetchUsers$: Subject<void>;
  updateUser$: Subject<{ id: string; data: Partial<UserCPanelModel> }>;
  totalUsersCount: number;
  setTotalUsersCount: Dispatch<SetStateAction<number>>;

  isOutOfSeatsDialogOpen: boolean;
  setIsOutOfSeatsDialogOpen: Dispatch<SetStateAction<boolean>>;
}

export const CPanelPageContext = createContext<CPanelPageContextValue | null>(
  null
);
